import Vue from 'vue';
import VueRouter from 'vue-router';
import Quiz from '../views/Quiz.vue';
import Login from '../views/Login.vue';
import Dashboard from '../views/Dashboard.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Quiz',
    component: Quiz,
  },
  {
    path: '/admin/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/admin/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('admin-token');
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/admin/login');
  } else {
    next();
  }
});

export default router;